<template>
    <button :disabled="loading" v-html="btnLabel" class="btn btn-danger btn-xs" @click="confirmDeleteCarrierArea">
    </button>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "CarrierAreaDeleteButton",
    props: {
        carrierArea: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        confirmDeleteCarrierArea() {
            Swal.fire({
                title: this.$t("CarrierAreaDeleteButton.youSureToDelete"),
                text: this.$t("CarrierAreaDeleteButton.youCantUndo"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("CarrierAreaDeleteButton.delete"),
                cancelButtonText: this.$t("CarrierAreaDeleteButton.cancel"),
            }).then(result => {
                if (result.value) {
                    this.deleteCarrierArea();
                }
            });
        },
        async deleteCarrierArea() {
            try {
                this.loading = true;
                await this.$diceAPI.deleteCarrierArea(this.carrierArea);
                this.$emit("deleteCarrierArea", this.carrierArea);
                this.$toasted.success(this.$t("CarrierAreaDeleteButton.carrierAreaDeleted"), { icon: "check" });
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
    },
    computed: {
        btnLabel() {
            return this.loading ? "<i class='fa fa-spin fa-spinner'></i>" : "<i class='fa fa-times'></i>";
        },
    },
};
</script>

<style scoped>

</style>